import React, { Component, Fragment } from "react";
import classNames from "classnames";
import { DEFAULT_CATEGORY_COLOR } from "constants/categoriesColors";

import "./accordionTab.scss";

const PropTypes = require("prop-types");

class AccordionTab extends Component {
    constructor(props) {
        super(props);
    }

    buildSelectedHeaderContent = () => {
        const { selected, FormattedText } = this.props;

        if (selected === 1) {
            return (
                <Fragment>
                    {selected}{" "}
                    <FormattedText value={'ngosSelector-selected'} />
                </Fragment>
            )
        } else if (selected > 1) {
            return (
                <Fragment>
                    {selected}{" "}
                    <FormattedText value={'ngosSelector-selectedPL'} />
                </Fragment>
            )
        }

        return null;
    }

    buildHeaderContent = () => {
        const {
            title,
            image,
            color,
            handler,
            isOpen,
            total,
            FormattedText
        } = this.props;


        const categoryName = (
            <FormattedText value={`ngoCategory-${title.split("-")[1]}Name`} />
        );

        const headerContent = (
            <span className="accordion__header__text">
                {categoryName}
                <span className="accordion__header__total">
                    ({total})
                </span>
            </span>
        )

        return (
            <div
                className="accordion__header"
                style={{ borderLeft: `2px solid ${color}` }}
                onClick={handler}
            >
                <img
                    src={image}
                    alt={title}
                    className="accordion__header-image"
                />

                {headerContent}
                <span className="accordion__header-selected">
                    {this.buildSelectedHeaderContent()}
                    <i
                        className={`accordion__header__icon icon-arrow-${isOpen ? "up" : "down"}`}
                    />
                </span>
            </div>
        );
    };

    buildBody = () => {
        const { isOpen, children, heightTab } = this.props;

        const bodyClass = classNames("accordion__body", {
            hidden__tab: !isOpen
        });

        // const heightCustomTab = isOpen ? `${heightTab + 20}px` : "0px";
        // const autoHeight = isOpen ? "auto" : "0px";

        return (
            <div
                style={{ display: isOpen ? 'block' : 'none' }}
                className={bodyClass}
            >
                {children}
            </div>
        );
    };

    render() {
        const header = this.buildHeaderContent();
        const body = this.buildBody();

        return (
            <div className="tab__container">
                {header}
                {body}
            </div>
        );
    }
}

AccordionTab.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.element.isRequired,
    isOpen: PropTypes.bool.isRequired,
    image: PropTypes.string,
    handler: PropTypes.func.isRequired,
    color: PropTypes.string,
    total: PropTypes.number,
    selected: PropTypes.number,
    FormattedText: PropTypes.func,
    heightTab: PropTypes.number
};

AccordionTab.defaultProps = {
    color: DEFAULT_CATEGORY_COLOR,
    FormattedText: () => {throw "FormattedText not defined"}
};

export default AccordionTab;
